import * as React from 'react';
import { createElement } from 'react';
import request from '@/utils/request';
import { Button, Dialog, Table, Notification, Form, Radio, Field, } from '@alifd/next';
const Backward = (props) => {
    const { tabhelper, displayName, procInstId, taskInstId, opinionFormInstance, validateForms, getFormValues, processType, } = props;
    const [okLoading, setOkLoading] = React.useState(false);
    const [visible, setVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [dataSource, setDataSource] = React.useState([]);
    const comment = React.useRef({});
    const [selectedRows, setSelectedRows] = React.useState([]);
    const formField = Field.useField();
    const getComment = () => {
        return comment.current;
    };
    const getForm = () => {
        return getFormValues();
    };
    const backward = async () => {
        setLoading(true);
        await queryTaskInstance();
        opinionFormInstance?.validate(async (error, values) => {
            if (!error) {
                comment.current = values;
                await validateForms().then(async (passed) => {
                    if (passed) {
                        await queryTaskInstance();
                    }
                    else {
                        setLoading(false);
                    }
                });
            }
            else {
                setLoading(false);
            }
        });
    };
    const queryTaskInstance = React.useCallback(async () => {
        setLoading(true);
        await request
            .get(`/api/process/task/back/${taskInstId}`)
            .then(({ content = [] }) => {
            setDataSource(content);
            setVisible(true);
        })
            .finally(() => setLoading(false));
    }, [taskInstId]);
    const handleOk = React.useCallback(() => {
        setOkLoading(true);
        formField.validate(async (error, values) => {
            if (!error) {
                const { originalPath } = values;
                await request
                    .post('/api/process/task/back', {
                    comment: getComment(),
                    procInstId,
                    taskInstId,
                    originalPath,
                    targetTaskDefKey: selectedRows[0].nodeCode,
                })
                    .then(() => {
                    Notification.success({ title: '退回成功!' });
                    setVisible(false);
                    tabhelper?.closeTab();
                })
                    .finally(() => {
                    setOkLoading(false);
                });
            }
            else {
                setOkLoading(false);
            }
        });
    }, [formField, procInstId, taskInstId, selectedRows, tabhelper]);
    const handleCancel = () => {
        setVisible(false);
    };
    return (createElement("div", null,
        createElement(Button, { onClick: backward, loading: loading }, displayName),
        createElement(Dialog, { v2: true, title: "\u6D41\u7A0B\u9000\u56DE\u5230", visible: visible, onOk: handleOk, onCancel: handleCancel, width: 1000, okProps: {
                loading: okLoading,
                disabled: selectedRows.length === 0,
            }, closeMode: ['close', 'esc', 'mask'], onClose: handleCancel },
            createElement(Table, { dataSource: dataSource, primaryKey: "nodeCode", rowSelection: {
                    mode: 'single',
                    onChange: (selectedRowKeys, records) => {
                        setSelectedRows(records);
                    },
                } },
                createElement(Table.Column, { title: "\u8282\u70B9\u540D\u79F0", dataIndex: "nodeName" }),
                createElement(Table.Column, { title: "\u7528\u6237\u540D\u79F0", dataIndex: "userName" }),
                createElement(Table.Column, { title: "\u90E8\u95E8\u540D\u79F0", dataIndex: "departmentName" })),
            createElement(Form, { useLabelForErrorMessage: true, field: formField, labelAlign: "left" },
                createElement(Form.Item, { label: "\u662F\u5426\u539F\u8DEF\u5F84\u4E0A\u62A5", name: "originalPath", required: true },
                    createElement(Radio.Group, { dataSource: [
                            {
                                label: '是',
                                value: true,
                            },
                            {
                                label: '否',
                                value: false,
                            },
                        ] }))))));
};
export default Backward;
